<template>
  <div class="filters-container">
    <select-campaigns-modal
      v-if="!hideOfferButton"
      v-model="computedFilters.campaigns"
      :mode="[]"
      :disabled="disableCampaigns"
      get-products
      only-offer-sales
      hide-industry
    />

    <mf-select-units-dialog
      :selected-units.sync="computedFilters.units"
      :selected-units-configuration.sync="computedFilters.unitsConfiguration"
      :units="units"
      :tag-list="tagList"
      :group-list="unitsGroups"
      hide-ecommerce-configuration
      template-type="badge-filter"
    />

    <modal-graphql-search-content :selected-items.sync="computedFilters.products" template-type="badge-filter" />

    <select-filter v-model="computedFilters.personType" variant="personType" multiple />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'NewReportDialogFilters',
  components: {
    SelectCampaignsModal: () => import('@/components/select-campaigns-modal/SelectCampaignsModal.vue'),
    ModalGraphqlSearchContent: () => import('@/components/ModalGraphqlSearchContent.vue'),
    SelectFilter: () => import('@/components/SelectFilter.vue'),
  },
  props: {
    filters: {
      type: Object,
      default: () => {},
    },
    disableCampaigns: {
      type: Boolean,
      default: false,
    },
    hideOfferButton: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['units', 'tagList', 'unitsGroups']),
    computedFilters: {
      get() {
        return this.filters
      },
      set(value) {
        this.$emit('update:filters', value)
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.filters-container {
  display: flex;
  align-items: center;
  gap: 32px;
  margin: 12px 0 24px;
}
</style>
